import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, SettingsIcon, CalculatorIcon, BookOpenIcon, MessageCircleIcon, PuzzleIcon, ClipboardListIcon, ClipboardCheckIcon, CalendarCheckIcon, FileTextIcon, ZapIcon, TrendingUpIcon, CheckIcon } from 'lucide-react';
export function Tomos() {
  const modules = [{
    label: 'Concentración',
    Icon: BrainIcon
  }, {
    label: 'Funciones Ejecutivas',
    Icon: SettingsIcon
  }, {
    label: 'Matemática y Razonamiento',
    Icon: CalculatorIcon
  }, {
    label: 'Lectoescritura',
    Icon: BookOpenIcon
  }, {
    label: 'Lenguaje',
    Icon: MessageCircleIcon
  }, {
    label: 'Memoria',
    Icon: PuzzleIcon
  }];
  const bonuses = [{
    label: 'Primera Consulta Resuelta',
    Icon: ClipboardListIcon
  }, {
    label: 'Evaluación Sin Caos',
    Icon: ClipboardCheckIcon
  }, {
    label: 'Sesiones Listas',
    Icon: CalendarCheckIcon
  }, {
    label: 'Informes Sin Bloqueo',
    Icon: FileTextIcon
  }, {
    label: 'Salvá la Sesión',
    Icon: ZapIcon
  }, {
    label: 'Seguimiento Sin Caos',
    Icon: TrendingUpIcon
  }];
  return <section className="w-full py-12 md:py-16 bg-transparent font-['Open_Sans',_sans-serif]" data-id="element-179" data-mp="3en2y515d3pdu">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-180" data-mp="3jhp7kyrvv7va">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative rounded-3xl border border-[#C084FC]/25 bg-gradient-to-b from-[#1C1530] to-[#16101F] p-6 md:p-9 overflow-hidden" data-id="element-181" data-mp="3odnvkl9aunv6">
          {/* Soft accent line top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-[#C084FC]/40 to-transparent" data-id="element-182" data-mp="1zzroukjlnu35" />

          {/* Headline block */}
          <div className="flex items-start gap-4 md:gap-5 mb-5" data-id="element-183" data-mp="1w0953s3ilp1w">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-[#C084FC]/15 border border-[#C084FC]/35 flex flex-col items-center justify-center leading-none" data-id="element-184" data-mp="29yqndaani9cf">
              <span className="text-[#C084FC] text-3xl md:text-4xl font-[900]" data-id="element-185" data-mp="2ixu80ipguwt1">
                12
              </span>
              <span className="text-[8px] md:text-[9px] uppercase tracking-[0.18em] text-[#D8B4FE] font-bold mt-1" data-id="element-186" data-mp="2ew907brsh8pp">
                recursos
              </span>
            </div>
            <div className="min-w-0" data-id="element-187" data-mp="2np2i7gymem79">
              <h2 className="text-2xl md:text-3xl font-[900] text-white tracking-tight leading-tight" data-id="element-188" data-mp="2nq43ee9cop2p">
                6 Módulos + 6 Bonos Profesionales
              </h2>
              <p className="text-[13px] md:text-[15px] text-[#D8B4FE] font-semibold mt-1.5" data-id="element-189" data-mp="2xoky9mbetnu1">
                12 recursos para acompañar tu práctica psicopedagógica
              </p>
            </div>
          </div>

          <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-7" data-id="element-190" data-mp="3ladggr0x2eee">
            Actividades listas para trabajar 6 áreas clave, más herramientas
            prácticas para organizar diferentes momentos de tu trabajo
            profesional.
          </p>

          {/* Modules — primary content */}
          <p className="text-[10px] uppercase tracking-[0.25em] text-[#C084FC] font-bold mb-4" data-id="element-191" data-mp="2xk18jg5o8hnt">
            6 Módulos Principales
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-8" data-id="element-192" data-mp="2ol652bu0hlo7">
            {modules.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-3 rounded-xl border border-[#C084FC]/20 bg-[#C084FC]/[0.07] px-3.5 py-3" data-id="element-193" data-mp="2tkshij20mxvy">
                <Icon className="w-4 h-4 text-[#C084FC] flex-shrink-0" aria-hidden="true" data-id="element-194" data-mp="2jlt6wuxows6b" />
                <span className="text-[13px] md:text-sm text-white font-semibold leading-snug" data-id="element-195" data-mp="3mvnx52sv3lu2">
                  {label}
                </span>
                <CheckIcon className="w-3.5 h-3.5 text-[#C084FC] flex-shrink-0 ml-auto" strokeWidth={3} aria-hidden="true" data-id="element-196" data-mp="3d648thmdqzrt" />
              </li>)}
          </ul>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-7" data-id="element-197" data-mp="336527q9itjhl" />

          {/* Bonuses — additional value */}
          <p className="text-[10px] uppercase tracking-[0.25em] text-gray-400 font-bold mb-4" data-id="element-198" data-mp="2u8upe0h21mak">
            + 6 Bonos Incluidos
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 mb-8" data-id="element-199" data-mp="2pat8nm73pz29">
            {bonuses.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-2.5" data-id="element-200" data-mp="nhljll1os336">
                <Icon className="w-3.5 h-3.5 text-[#D8B4FE]/70 flex-shrink-0" aria-hidden="true" data-id="element-201" data-mp="nf95jiz1ucve" />
                <span className="text-[13px] md:text-sm text-gray-300 leading-snug" data-id="element-202" data-mp="zyw9psk5bp0j">
                  {label}
                </span>
              </li>)}
          </ul>

          {/* Closing highlight */}
          <p className="rounded-xl border border-[#C084FC]/30 bg-[#C084FC]/10 px-4 py-3 text-center text-[11px] md:text-[13px] font-[800] uppercase tracking-[0.12em] text-[#D8B4FE] leading-relaxed" data-id="element-203" data-mp="19ofwh9azc30o">
            Actividades + Evaluación + Planificación + Informes + Seguimiento
          </p>
        </motion.div>
      </div>
    </section>;
}